
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SectionTitle } from "@/components/SectionTitle";
import { CheckCircle, Calendar, ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { PageTitle } from "@/components/PageTitle";

const AppointmentThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <PageTitle title="Thank You – Asrani Dental Clinic" />
      <Header />
      
      <main className="flex-grow pt-32 pb-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center bg-white rounded-xl shadow-md p-8 md:p-12">
            <div className="w-20 h-20 bg-dental-highlight/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={40} className="text-dental-highlight" />
            </div>
            
            <SectionTitle 
              title="Thank You For Your Appointment Request!" 
              subtitle="Request Received"
              description="We have received your appointment request and our team will contact you shortly to confirm the details."
            />
            
            <div className="mt-8 p-6 bg-dental-offwhite rounded-lg">
              <h3 className="text-lg font-medium mb-4 flex items-center justify-center">
                <Calendar size={20} className="mr-2 text-dental-highlight" />
                What Happens Next?
              </h3>
              
              <ul className="space-y-3 text-dental-text text-left max-w-md mx-auto">
                <li className="flex items-start">
                  <span className="font-medium mr-2">1.</span>
                  <span>Our team will review your appointment request within 24 hours.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-medium mr-2">2.</span>
                  <span>We'll contact you via phone or email to confirm your appointment time and date.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-medium mr-2">3.</span>
                  <span>You'll receive a confirmation message with appointment details.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-medium mr-2">4.</span>
                  <span>Feel free to call us if you need to adjust your appointment or have any questions.</span>
                </li>
              </ul>
            </div>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <Button className="btn-outline flex items-center gap-2" asChild>
                <Link to="/dental-appointment-booking">
                  <ArrowLeft size={16} />
                  Back to Appointments
                </Link>
              </Button>
              
              <Button className="btn-primary flex items-center gap-2" asChild>
                <Link to="/">
                  <Home size={16} />
                  Return to Homepage
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AppointmentThankYou;
